import { GET, PUT } from "../../../api";

const SWAP_BASE =
  process.env.REACT_APP_SWAP_BASE_URL || "http://127.0.0.1:4243/api/v1";

export const findAll = async (roundId) => {
  return await GET(
    `/admin/manual-result/bet-counts${roundId ? `?round_id=${roundId}` : ""}`,
  );
};

// Served by win3xswapgame, which decides the result.
export const getManualResult = async (roundId) => {
  return await GET(`/admin/88q/manual-result?round_id=${roundId}`, {}, SWAP_BASE);
};

// position: 0 left, 1 center, 2 right, null = automatic
// multiple: extra X on top of the App Setup payout (1 = normal)
export const setManualResult = async (roundId, position, multiple = 1) => {
  return await PUT(
    `/admin/88q/manual-result`,
    { round_id: roundId, position, multiple },
    SWAP_BASE,
  );
};
